module.exports = __webpack_public_path__ + "img/CIOGlobal.d2e1d763.jpg";